var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading-container"}):(_vm.reportType === 'audit_report')?_c('div',[_c('AuditReportDetail')],1):_c('div',[_c('ProspectusDetail',{attrs:{"report-type":_vm.reportType}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }